import { setShowSupplierItemModal } from '../State/showSupplierItemModal';
import { setSupplierItemForEdit } from '../State/supplierItemForEdit';

export default (item) => async (dispatch) => {
  dispatch(setSupplierItemForEdit(item));
  dispatch(setShowSupplierItemModal(true));
}
